// Core
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../../Middleware/axiosConfig";

// Utils
import { notifyError } from "Services/Utils/toastNotification";

// API End Points
import { API_END_POINTS } from "Middleware/apiEndpoints";

export const getAssessmentTrackerListRequest_ACCESSOR = createAsyncThunk(
  "getAssessmentTrackerListRequest_ACCESSOR",
  async (data) => {
    // Construct the base URL for the API request
    let url = `${API_END_POINTS.getAssessmentTrackerListRequest_ACCESSOR}${data?.page}&sort_by=${data?.sortBy}`;

    // Conditionally append the filterValue parameter only if it has a value
    if (data?.search) {
      url += `&search=${data.search}`;
    }

    // Conditionally append the order_by parameter only if orderBy has a value
    if (data?.orderBy) {
      url += `&order_by=${data.orderBy}`;
    }
    if (data?.start_date) {
      url += `&start_date=${data.start_date}`;
    }
    if (data?.due_date) {
      url += `&due_date=${data.due_date}`;
    }
    if (data?.status) {
      url += `&status=${data.status}`;
    }
    if (data?.company_type_name) {
      url += `&company_type_name=${data.company_type_name}`;
    }
    if (data?.industry_name) {
      url += `&industry_name=${data.industry_name}`;
    }

    // Make the API call
    const response = await APIKit().get(url);

    // Handle the response
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }

    return response?.data;
  }
);

//Get Assessment Review List Request
export const getAssessmentReviewListRequest_ACCESSOR = createAsyncThunk(
  "getAssessmentReviewListRequest_ACCESSOR",
  async (data) => {
    // Construct the base URL for the API request
    let url = `${API_END_POINTS.getAssessmentReviewListRequest_ACCESSOR}${data?.page}&sort_by=${data?.sortBy}${data?.search ? `&search=${data.search}` : ''}`;

    // Conditionally append the filterValue parameter only if it has a value
    if (data?.filter) {
      url += `&filterValue=${data.filter}`;
    }

    // Conditionally append the order_by parameter only if orderBy has a value
    if (data?.orderBy) {
      url += `&order_by=${data.orderBy}`;
    }

    // Make the API call
    const response = await APIKit().get(url);

    // Handle the response
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }

    return response?.data;
  }
);

export const getCompanyType = createAsyncThunk(
  "getCompanyType",
  async (data) => {
    // api hit
    const response = await APIKit().get(`${API_END_POINTS.getCompanyType}`);
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getCategoryAndSubCategory = createAsyncThunk(
  "getAllQuestions_USER",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAllQuestions_USER}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getUserAnswer = createAsyncThunk("getUserAnswer", async (data) => {
  // api hit
  const response = await APIKit().get(
    `${API_END_POINTS.getUserAnswer}?assessment_id=${data?.assessment_id}&category_id=${data?.category_id}&sub_category_id=${data?.sub_category_id}&company_name=${data?.company_name}`
  );
  if (response?.status === 200) {
    data?.callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
  }
  return response?.data;
});

// GET API for Previous Answer
export const getPreviousAnswerDetails = createAsyncThunk(
  "getPreviousData",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getPreviousData}?assessment_id=${data?.assessment_id}&category_id=${data?.category_id}&sub_category_id=${data?.sub_category_id}&question_id=${data?.question_id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

// GET API For Additional insights
export const getAdditionalInsightsDetail = createAsyncThunk(
  "getAdditionalInsights",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getAdditionalInsights}?assessment_id=${data?.assessment_id}&category_id=${data?.category_id}&company_name=${data?.company_name}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

// Post API for Assessment Review View
export const addAssessmentAnswerScore = createAsyncThunk(
  "addUserAnswerResearchAndRecommendation",
  async (data) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addUserAnswerResearchAndRecommendation}`,
      data?.data
    );
    if (response?.status === 201) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

// Post API for Assessment Review View
export const updateAssessmentAnswerScore = createAsyncThunk(
  "updateUserAnswerResearchAndRecommendation",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.updateUserAnswerResearchAndRecommendation}`,
      data?.data
    );
    if ([200, 201].includes(response?.status)) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

// To get the approval list
export const getApprovalListRequest_ACCESSOR = createAsyncThunk(
  "getApprovalListRequest_ACCESSOR",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getApprovalListRequest_ACCESSOR}${data?.page}&limit=${data?.limit}&order_by=${data?.orderBy}&sort_by=${data?.sortBy}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get dashboard backlog counts request
export const getDashboardBacklogCountsRequest_ACCESSOR = createAsyncThunk(
  "getDashboardBacklogCountsRequest_ACCESSOR",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getDashboardBacklogCountsRequest_ACCESSOR}${data?.period}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get assessments submitted by companies request
export const getAssessmentsSubmittedByCompaniesRequest_ACCESSOR =
  createAsyncThunk(
    "getAssessmentsSubmittedByCompaniesRequest_ACCESSOR",
    async (data) => {
      // api hit
      const response = await APIKit().get(
        `${API_END_POINTS.getAssessmentsSubmittedByCompaniesRequest_ACCESSOR}${data?.period}`
      );
      if (response?.status === 200) {
        data?.callBack(response?.data?.data);
      } else {
        notifyError(response?.data?.message);
      }
      return response?.data;
    }
  );

// Post API for Spare Parts Log
export const addSparePartsLog = createAsyncThunk(
  "addSparePartsLog",
  async (data) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addSparePartsLog}`,
      data?.data
    );
    if (response?.status === 201) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const addSpartParts = createAsyncThunk(
  "addSpartParts",
  async (data) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.spartParts}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
)

export const getSpareParts =
  createAsyncThunk(
    "getSpareParts",
    async (data) => {
      // api hit
      const response = await APIKit().get(
        `${API_END_POINTS.spartParts}?backlog_id=${data?.assessment_id}`
      );
      if (response?.status === 200) {
        data?.callBack(response?.data?.data);
      } else {
        notifyError(response?.data?.message);
      }
      return response?.data;
    }
  );

export const updateSparePartsLog = createAsyncThunk(
  "updateSparePartsLog",
  async (data) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.updateSparePartsLog}`,
      data?.data
    );
    if (response?.status === 201) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getDropDownData = createAsyncThunk(
  "getDropDownData",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getDropDownData}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getProductName = createAsyncThunk(
  "getProductName",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getProductName}/${data?.moduleId}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getStoreAuditData = createAsyncThunk(
  "getStoreAuditData",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getStoreAuditData}/${data?.backlog_id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const addOrUpdateStoreAuditData = createAsyncThunk(
  "addOrUpdateStoreAuditData",
  async (data) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.addOrUpdateStoreAuditData}`,
      data?.data
    );
    if (response?.status === 200) {
      data?.callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//GET by Id API for Preview in Assessment Submitted
export const getPreviewDetail = createAsyncThunk(
  "getPreviewDetail",
  async (data) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getPreviewDetail}/${data?.assessment_id}`
    );
    if (response?.status === 200) {
      data?.callBack(response?.data?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

//Get accessor list for assessmentBL request
const accessorSlice = createSlice({
  name: "accessor",
  initialState: { isLoading: false, company_name: "" },
  reducers: { setCompanyName: (state, action) => { state.company_name = action.payload } },
  extraReducers: (builder) => {
    //Get Assessment Tracker List Request
    builder
      .addCase(getAssessmentTrackerListRequest_ACCESSOR.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        getAssessmentTrackerListRequest_ACCESSOR.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        getAssessmentTrackerListRequest_ACCESSOR.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Get Assessment Review List Request
    builder
      .addCase(getAssessmentReviewListRequest_ACCESSOR.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        getAssessmentReviewListRequest_ACCESSOR.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        getAssessmentReviewListRequest_ACCESSOR.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Get dashboard backlog counts request
    builder
      .addCase(getDashboardBacklogCountsRequest_ACCESSOR.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        getDashboardBacklogCountsRequest_ACCESSOR.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        getDashboardBacklogCountsRequest_ACCESSOR.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    // Get Preview Details
    //Get dashboard backlog counts request
    builder
      .addCase(getPreviewDetail.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(
        getPreviewDetail.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        getPreviewDetail.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );

    //Get assessments submitted by companies request
    builder
      .addCase(
        getAssessmentsSubmittedByCompaniesRequest_ACCESSOR.pending,
        (state) => {
          state.isLoading = "loading";
        }
      )
      .addCase(
        getAssessmentsSubmittedByCompaniesRequest_ACCESSOR.fulfilled,
        (state, action) => {
          state.isLoading = "succeeded";
        }
      )
      .addCase(
        getAssessmentsSubmittedByCompaniesRequest_ACCESSOR.rejected,
        (state, action) => {
          state.isLoading = "failed";
        }
      );
  },
});

export const { setCompanyName } = accessorSlice.actions
export default accessorSlice.reducer;
